import { render, staticRenderFns } from "./swPostPreview.vue?vue&type=template&id=3128673a&"
import script from "./swPostPreview.vue?vue&type=script&lang=js&"
export * from "./swPostPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports